import { PageLoader } from '@/shared/ui';

export function BloodReportPending() {
  return <PageLoader alt="BLOOD_REPORT.PENDING.DESCRIPTION" />;
}
